import Server from "../server";

export default class ServerService {

	static ping() {
		return Server.ping();
	}
}
